import { useQuery, useQueryClient } from "@tanstack/react-query";
import { fetchAllPayments } from "../app/api/payments";
import type { Payments } from "../types";

export function usePayments() {
  return useQuery<Payments[], Error>({
    queryKey: ["payments"],
    queryFn: fetchAllPayments,
    staleTime: 1000,
    retry: 1,
  });
}

export function usePayment(id: string) {
  const queryClient = useQueryClient();

  const cached = queryClient.getQueryData<Payments[]>(["users"]);
  const initial = cached?.find((u) => u._id === id) ?? null;

  return useQuery<Payments | null, Error>({
    queryKey: ["user", id],
    enabled: !initial,
    initialData: initial,
    queryFn: async () => {
      const users = await fetchAllPayments();
      const u = users.find((u) => u._id === id);
      if (!u) throw new Error("User not found");
      return u;
    },
  });
}
